export enum localStorageEnum {
    USER = "user",
    ACCOUNT_GOVBR = "account"
}